export enum ScheduleDetourFormFields {
  DtrFields = 'DetourFields',
  DtrHwUsed = 'dtrHwUsed',
  DtrState = 'dtrState',
  DtrTotalExMil = 'dtrTotalExMil',
}
